const ADP_REFERRAL_STORAGE_KEY = 'adp_referral_submit';

export function getAdpReferralStorageKey(businessEntityUuid) {
  return `${ADP_REFERRAL_STORAGE_KEY}:${businessEntityUuid}`;
}

export function isAdpReferralSubmitted(businessEntityUuid) {
  if (!businessEntityUuid || typeof window === 'undefined') {
    return false;
  }

  return Boolean(localStorage.getItem(getAdpReferralStorageKey(businessEntityUuid)));
}

export function setAdpReferralSubmitted(businessEntityUuid) {
  if (!businessEntityUuid || typeof window === 'undefined') {
    return;
  }

  localStorage.setItem(getAdpReferralStorageKey(businessEntityUuid), 'true');
}
